import Skeleton from '@mui/material/Skeleton';

export const AssignmentSummaryCardSkeleton = () => (
  <Skeleton height={250} sx={{ mb: 4, mt: 10 }} />
);
